<script>
  import { format } from "d3-format";
  import katexify from "../katexify";
  import { scaleLinear } from "d3-scale";
  import ClosedFormScatterplot from "./ClosedFormScatterplot.svelte";
  import { matrixDot, transpose } from "../utils";
  import { cfBias, cfWeight, cfCircles, cfWidth, cfHeight } from "../store.js";
  let closedFormScatterClass;

  // label formatter
  const formatter = format(".2f");
  const matForm = format(".1f");

  function resetCircles() {
    $cfCircles = [];
  }
  $: X = $cfCircles.map((d) => [1, d.cx]);
  $: Y = $cfCircles.map((d) => [d.cy]);

  $: if ($cfCircles.length > 1) {
    let xT = transpose(X);
    let xProd = matrixDot(transpose(X), X);
  }

  $: xProd =
    $cfCircles.length > 1
      ? matrixDot(transpose(X), X)
      : [
          [0, 0],
          [0, 0],
        ];

  let width = 500;
  let height = 500;

  const margin = {
    top: 50,
    bottom: 3,
    left: 30,
    right: 30,
  };

  // scales
  $: xScale = scaleLinear()
    .domain([0, 100])
    .range([margin.left, $cfWidth - margin.right]);
  $: yScale = scaleLinear()
    .domain([0, 100])
    .range([$cfHeight - margin.bottom, margin.top]);

  $: newcfCircles = $cfCircles.map((d) => {
    return {
      cx: matForm(xScale.invert(d.cx)),
      cy: matForm(yScale.invert(d.cy)),
    };
  });
</script>

<section>
  <div id="cf-container">
    <div id="equations-container">
      <br />
      <div id="equation-math">
        {@html katexify(
          `\\begin{aligned}
        
        \\hat{\\beta} = (X^{T}X)^{-1}X^{T}Y \\\\
         = \\begin{pmatrix} 
         \\begin{bmatrix}
            1 & ${newcfCircles?.[0] ? newcfCircles[0].cx : 0} \\\\
            ${newcfCircles?.[1] ? `1 & ${newcfCircles[1].cx} \\\\` : ""} 
            ${
              newcfCircles.length > 3
                ? `\\vdots & \\vdots \\\\`
                : newcfCircles?.[2]
                ? `1 & ${newcfCircles[2].cx} \\\\`
                : ""
            } 
            ${
              newcfCircles.length > 3
                ? `1 & ${newcfCircles.at(-1).cx}`
                : newcfCircles?.[3]
                ? `1 & ${newcfCircles[3].cx}`
                : ""
            } 
            \\end{bmatrix}^T 
            \\begin{bmatrix}
            1 & ${newcfCircles?.[0] ? newcfCircles[0].cx : 0} \\\\
            ${newcfCircles?.[1] ? `1 & ${newcfCircles[1].cx} \\\\` : ""} 
            ${
              newcfCircles.length > 3
                ? `\\vdots & \\vdots \\\\`
                : newcfCircles?.[2]
                ? `1 & ${newcfCircles[2].cx} \\\\`
                : ""
            } 
            ${
              newcfCircles.length > 3
                ? `1 & ${newcfCircles.at(-1).cx}`
                : newcfCircles?.[3]
                ? `1 & ${newcfCircles[3].cx}`
                : ""
            } 
            \\end{bmatrix}
            \\end{pmatrix}^{-1} 
            \\begin{bmatrix}
            1 & ${newcfCircles?.[0] ? newcfCircles[0].cx : 0} \\\\
            ${newcfCircles?.[1] ? `1 & ${newcfCircles[1].cx} \\\\` : ""} 
            ${
              newcfCircles.length > 3
                ? `\\vdots & \\vdots \\\\`
                : newcfCircles?.[2]
                ? `1 & ${newcfCircles[2].cx} \\\\`
                : ""
            } 
            ${
              newcfCircles.length > 3
                ? `1 & ${newcfCircles.at(-1).cx}`
                : newcfCircles?.[3]
                ? `1 & ${newcfCircles[3].cx}`
                : ""
            } 
            \\end{bmatrix}^T 
            \\begin{bmatrix}
            ${newcfCircles?.[0] ? newcfCircles[0].cy : 0} \\\\
            ${newcfCircles?.[1] ? `${newcfCircles[1].cy} \\\\` : ""} 
            ${
              newcfCircles.length > 3
                ? `\\vdots \\\\`
                : newcfCircles?.[2]
                ? `${newcfCircles[2].cy} \\\\`
                : ""
            } 
            ${
              newcfCircles.length > 3
                ? `${newcfCircles.at(-1).cy}`
                : newcfCircles?.[3]
                ? `${newcfCircles[3].cy}`
                : ""
            } 
            \\end{bmatrix}
            \\\\

            

            =  
            \\begin{pmatrix}
         \\begin{bmatrix}
            ${xProd[0][0]} & ${xProd[0][1]} \\\\
            ${xProd[1][0]} & ${xProd[1][1]}
            \\end{bmatrix}
            \\end{pmatrix}^{-1}
            \\begin{bmatrix}
            1 & ${newcfCircles?.[0] ? newcfCircles[0].cx : 0} \\\\
            ${newcfCircles?.[1] ? `1 & ${newcfCircles[1].cx} \\\\` : ""} 
            ${
              newcfCircles.length > 3
                ? `\\vdots & \\vdots \\\\`
                : newcfCircles?.[2]
                ? `1 & ${newcfCircles[2].cx} \\\\`
                : ""
            } 
            ${
              newcfCircles.length > 3
                ? `1 & ${newcfCircles.at(-1).cx}`
                : newcfCircles?.[3]
                ? `1 & ${newcfCircles[3].cx}`
                : ""
            } 
            \\end{bmatrix}^T 
            \\begin{bmatrix}
            ${newcfCircles?.[0] ? newcfCircles[0].cy : 0} \\\\
            ${newcfCircles?.[1] ? `${newcfCircles[1].cy} \\\\` : ""} 
            ${
              newcfCircles.length > 3
                ? `\\vdots \\\\`
                : newcfCircles?.[2]
                ? `${newcfCircles[2].cy} \\\\`
                : ""
            } 
            ${
              newcfCircles.length > 3
                ? `${newcfCircles.at(-1).cy}`
                : newcfCircles?.[3]
                ? `${newcfCircles[3].cy}`
                : ""
            } 
            \\end{bmatrix}

            \\\\
            =  
         \\begin{bmatrix}
            1 & ${newcfCircles?.[1] ? formatter($cfBias) : 0} \\\\
            1 &${newcfCircles?.[1] ? formatter($cfWeight) : 0}
            \\end{bmatrix}
            
            
        \\end{aligned}
        
        
        `,
          true
        )}
      </div>
    </div>
    <div id="charts-container">
      <ClosedFormScatterplot bind:this={closedFormScatterClass} />
    </div>
    <div class="button-container">
      <button on:click={resetCircles}>Reset</button>
    </div>
  </div>
</section>

<style>
  #cf-container {
    display: grid;
    grid-template-columns: 50% 50%;
    font-family: var(--font-mono);
    margin: auto;
    max-width: 1000px;
    height: 70vh;
    max-height: 500px;
    justify-content: center;
  }

  #equations-container {
    text-align: center;
    display: flex;
    flex-direction: column;
  }

  button:hover {
    outline: 2px solid var(--squidink);
  }

  button:active {
    color: var(--squidink);
  }

  button:visited {
    color: var(--white);
  }

  button {
    background-color: var(--smile);
    border: none;
    color: white;
    padding: 8px 16px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    margin: 4px 2px;
    cursor: pointer;
  }

  .button-container {
    max-width: var(--max-width);
    display: flex;
    margin: 1rem auto;
    justify-content: center;
  }
  #charts-container {
    display: grid;
    grid-template-columns: 100%;
    grid-column-gap: 0rem;
    grid-template-rows: 100%;
    height: 80vh;
    padding-right: 1rem;
    max-height: 500px;
    max-width: 100%;
    justify-content: center;
    align-items: center;
  }

  #charts-container svg {
    width: 100% !important;
    height: 100% !important;
    max-width: 450px;
    max-height: 400px;
    display: block;
    margin: 0 auto;
  }

  /* mobile */
  @media screen and (max-width: 950px) {
    #cf-container {
      grid-template-columns: 100%;
      max-width: 100%;
      width: 100%;
      height: 100%;
      max-height: 100%;
      margin: auto;
    }

    #charts-container {
      max-width: 100%;
      padding-right: 0;
      height: 40vh;
      max-height: 40vh;
    }
    #charts-container svg {
      max-width: 100vw;
      max-height: 40vh;
      height: 100% !important;
    }
  }
</style>
